import { CarYearConfig } from 'data-layer-cr/dist/models';
import CatalogItem from 'src/models/helperTypes/CatalogItem';

type CarStateValues = 'new' | 'old';

export const shouldShowCarStateInput = (
  carYearConfig: CarYearConfig | undefined,
): boolean => {
  if (carYearConfig) {
    return !carYearConfig.disabled;
  }
  return true;
};

export const carStateConfigValue = (value: CarStateValues): boolean =>
  value === 'old';

export const selectedModelFound = (
  modelsList: CatalogItem[],
  value: string,
): boolean => {
  return (
    typeof modelsList.find((model) => model.Value === value) !== 'undefined'
  );
};

export const getUseOptionFromUseValue = (value: string): string => {
  if (value === 'C') {
    return 'COMERCIAL';
  }
  if (value === 'P') {
    return 'PARTICULAR';
  }
  return '';
};
